import NoSSR from 'react-no-ssr';
import MediaQuery from 'react-responsive';

import { trans, getResourcePath } from '@spotahome/soyuz/client';

import SectionHeading from '@spotahome/landings-common/src/components/SectionHeading';

import {
  MQ_TABLET_MIN_WIDTH,
  MQ_MOBILE_MAX_WIDTH
} from '@spotahome/ui-library/src/tenant/components/utils/seoConstants';

import './AboutStart.scss';

const AboutStart = () => (
  <div className="wrapper">
    <SectionHeading text={trans('about-us.start.title')} />

    <figure className="about-start__image">
      <NoSSR>
        <MediaQuery minWidth={MQ_TABLET_MIN_WIDTH}>
          <img
            alt="co-founders"
            src={getResourcePath('/images/about-us/desktop-cofounders.jpg')}
          />
        </MediaQuery>
      </NoSSR>

      <NoSSR>
        <MediaQuery maxWidth={MQ_MOBILE_MAX_WIDTH}>
          <img
            alt="co-founders"
            src={getResourcePath('/images/about-us/mobile-cofounders.jpg')}
          />
        </MediaQuery>
      </NoSSR>
    </figure>

    <div className="one-col one-col--center">
      <p className="mb-xl">{trans('about-us.start.paragraph-1')}</p>
      <p className="mb-xl">{trans('about-us.start.paragraph-2')}</p>
      <p className="mb-xl">{trans('about-us.start.paragraph-3')}</p>
      <ul className="mb-xl">
        <li>{trans('about-us.start.list.item-1')}</li>
        <li>{trans('about-us.start.list.item-2')}</li>
      </ul>
      <p>{trans('about-us.start.paragraph-4')}</p>
    </div>
  </div>
);

export default AboutStart;
